// extracted by mini-css-extract-plugin
export default {"multiple-customer":"multiple-customer_multiple-customer__S7JoE"};